import { useTranslation } from "react-i18next";
import { Box, Divider, Tab, Tabs, SxProps } from "@mui/material";

const branchDetails = ["basic-info", "working-hours", "sports", "facilities"] as const;
type TabType = (typeof branchDetails)[number];

const BranchDetailsTabs = ({ activeTab, onTabChange }: { activeTab: TabType; onTabChange: (tab: TabType) => void }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });

  const handleTabChange = (_: React.SyntheticEvent, newValue: TabType) => {
    onTabChange(newValue);
  };

  return (
    <Box sx={styles.container}>
      <Divider orientation="horizontal" sx={styles.divider} />
      <Box sx={styles.tabsContainer}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="profile tabs"
          sx={styles.tabs}
          variant="scrollable"
          scrollButtons="auto"
        >
          {branchDetails.map((tab) => (
            <Tab key={tab} label={t(tab)} value={tab} sx={styles.tab} />
          ))}
        </Tabs>
      </Box>
      <Divider orientation="horizontal" sx={styles.divider} />
    </Box>
  );
};

export default BranchDetailsTabs;

export { default as BasicInfoTab } from "./BasicInfoTab";
export { default as WorkingHoursTab } from "./WorkingHoursTab";
export { default as SportsTab } from "./SportsTab";
export { default as FacilitiesTab } from "./FacilitiesTab";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%",
  } as SxProps,
  divider: {
    flex: 1,
    display: { xs: "none", sm: "block" },
  } as SxProps,
  tabsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: { xs: "100%", sm: "fit-content" },
    borderRadius: "8px",
    border: "1px solid var(--Gray-300, #D0D5DD)",
  } as SxProps,
  tabs: {
    minHeight: "fit-content",
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTabs-flexContainer": {
      gap: "0",
    },
  } as SxProps,
  tab: {
    color: "var(--Gray-700, #344054)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    textTransform: "none",
    minHeight: "fit-content",
    minWidth: "fit-content",
    padding: "10px 16px",
    borderRight: "1px solid var(--Gray-300, #D0D5DD)",
    "&:last-child": {
      borderRight: "none",
    },
    "&.Mui-selected": {
      color: "var(--Gray-800, #182230)",
      background: "#F2F5F7",
    },
  } as SxProps,
} as const;
